module.exports = __webpack_public_path__ + "img/Vector21.57e69906.png";